module.exports = {
      id: "plan-selected-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#plan-selected-usage",
      toString: function () {
        return this.url;
      }
    }